/**
 * Classify a paragraph group as a heading and assign a level (1-4).
 *
 * Signals (each paragraph group gets a score; threshold determines level):
 *   - Font size relative to page median (>1.4× → strong; >1.2× + bold → strong)
 *   - All-bold content
 *   - Short line count (≤3 lines) and short total length
 *   - Standalone (single line in paragraph group)
 *
 * Levels:
 *   - L1: ≥ 1.8× page median OR (≥1.5× + bold + standalone)
 *   - L2: ≥ 1.4× page median, OR (≥ 1.2× + bold)
 *   - L3: ≥ 1.2× page median + bold + ≤2 lines
 *   - L4: bold + standalone + short (single line, ≤8 words)
 *   - 0 (not a heading) otherwise
 */
export function classifyHeading(group, pageStats) {
    if (!pageStats)
        return 0;
    const median = pageStats.medianHeight;
    const ratio = group.height / median;
    const isStandalone = group.lines.length === 1;
    const allBold = isAllBold(group);
    const totalText = totalTextLength(group);
    const wordCount = countWords(group);
    // Disqualify long blocks regardless of size — true headings are short.
    if (totalText > 200 || group.lines.length > 4)
        return 0;
    if (ratio >= 1.8)
        return 1;
    if (ratio >= 1.5 && allBold && isStandalone)
        return 1;
    if (ratio >= 1.4)
        return 2;
    if (ratio >= 1.2 && allBold)
        return 2;
    if (ratio >= 1.15 && allBold && group.lines.length <= 2)
        return 3;
    if (allBold && isStandalone && wordCount <= 8 && wordCount >= 1)
        return 4;
    return 0;
}
function isAllBold(group) {
    let total = 0;
    let bold = 0;
    for (const line of group.lines) {
        for (const it of line.items) {
            total++;
            if (it.bold)
                bold++;
        }
    }
    if (total === 0)
        return false;
    return bold / total >= 0.8;
}
function totalTextLength(group) {
    let total = 0;
    for (const line of group.lines) {
        for (const it of line.items)
            total += it.str.length;
    }
    return total;
}
function countWords(group) {
    let count = 0;
    for (const line of group.lines) {
        for (const it of line.items) {
            count += it.str.split(/\s+/).filter((s) => s.length > 0).length;
        }
    }
    return count;
}
//# sourceMappingURL=headings.js.map